import * as React from "react";
import Error404 from "../pages/404";
import ComingSoon from "../pages/coming-soon";

export const routesConfig = [
    {
        name: "Coming Soon",
        class: "coming-soon",
        group: "temp",
        path: "/",
        title: "Coming Soon",
        element: <ComingSoon />
    },
    {
        name: "404",
        class: "error",
        group: "error",
        path: "*",
        title: "404",
        element: <Error404 />
    }
];
